export default {
  map_unavailable: 'De kaart kon niet worden geladen. Laad de pagina opnieuw om het nog eens te proberen.',
  stubs: {
    name: 'Bezorgzone {{number}}',
  },
  buttons: {
    add_new_zone: 'Nieuwe zone toevoegen',
  },
  toasts: {
    failed_to_load_data: 'Laden van bezorgzones mislukt',
  },
};
